import React, { useState, useEffect } from "react";
import { Table, Space, Descriptions, Divider, Input } from "antd";
import "../bundleTransport/bundleTransport.scss";
import { getStorage, getDownloadURL, ref as imageRef } from "firebase/storage";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../common/spinner";
import { Col, Row } from "react-bootstrap";
import { Button, Modal } from 'antd';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getMapIdBasedonEnvironment, log, timestampToDateFull } from "../../helper/helper";
import * as service from "./bundledOrderListServices";
import origin from "../../assets/origin.png";
import destination from "../../assets/destination.png";
import profileImage from "../../assets/profile.png";


import {
    GoogleMap,
    Marker,
    Polyline,
    OverlayView,
} from "@react-google-maps/api";
import decodePolyline from "decode-google-map-polyline";

function BundledOrderSingle(props) {
    const [isLoading, setLoading] = useState(true);
    const [map, setMap] = useState(null);
    const [transportData, setTransportData] = useState();
    const [rightMapPositions, setRightMapPositions] = useState([]);
    const [leftMapPositions, setLeftMapPositions] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editedData, setEditedData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [transportRiderInfo, setTransportRiderInfo] = useState();
    const [riderImage, setRiderImage] = useState(profileImage);
    const [riderItems, setRiderItems] = useState([]);
    const [showAssignToNewRider, setShowAssignToNewRider] = useState(false);
    const [showRiderListModal, setShowRiderListModal] = useState(false);

    const [assignTransportRiding, setAssignTransportRiding] = useState(false);
    const [assignTransportDriving, setAssignTransportDriving] = useState(false);
    const [assignBearerType, setAssignBearerType] = useState("");
    const [searchRiderLimitOnlineStateTime, setSearchRiderLimitOnlineStateTime] =
        useState("");
    const [assignBearerRiders, setAssignBearerRiders] = useState([]);


    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        adminCancelBundledTransports()
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const orderNumber = props.location.state.orderNumber;
    const orderDetail = props.location.state.orderDetail;
    useEffect(() => {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            if (!user) {
                return props.history.replace("/login");
            }
        });
        if (orderNumber != null) {
            return adminFindBundledTransports(orderNumber)
        } else if (orderDetail != null) {
            setLoading(false)
            return handleBundleData(orderDetail)
        } else {
            return props.history.push("/home")
        }

    }, [orderNumber, orderDetail]);

    useEffect(() => {
        if (transportData) {
            setEditedData(
                transportData.original_transport_details_for_admin.map((row) => ({
                    ...row
                }))
            );
        }

    }, [transportData]);


    const getRiderAvatar = (imageUrl) => {
        const storage = getStorage();
        const starsRef = imageRef(storage, imageUrl);
        getDownloadURL(starsRef)
            .then((url) => {
                setRiderImage(url);
            })
            .catch((error) => { });
    };

    const handleTransportModeImage = (transport) => {
        switch (transport) {
            case "cycling":
                return (
                    <img
                        style={{ width: 45, display: "block", margin: "0 auto" }}
                        src={require("../../assets/cycling.png")}
                        alt="walk"
                    />
                );
            case "riding":
                return (
                    <img
                        style={{ width: 45, display: "block", margin: "0 auto" }}
                        src={require("../../assets/riding.png")}
                        alt="walk"
                    />
                );
            case "walking":
                return (
                    <img
                        style={{ width: 45, display: "block", margin: "0 auto" }}
                        src={require("../../assets/walking.png")}
                        alt="walk"
                    />
                );
            default:
                break;
        }
    };


    const loadLeftGoogleMap = () => {
        return (
            <GoogleMap
                mapContainerStyle={containerStyle}
                zoom={13}
                onLoad={(mapInstance) => onLoadBounds(mapInstance, leftMapPositions)}
                onUnmount={onUnmount}
                defaultOptions={defaultMapOptions}
                options={{
                    mapId: getMapIdBasedonEnvironment(),
                }}
            >
                {leftMapPositions.map((marker) => (
                    <Marker
                        position={marker}
                        key={marker.lat + marker.lng + Math.random()}
                        icon={{
                            url: marker.icon,
                        }}
                    />
                ))}
                {transportData.original_transport_details_for_admin.map((trip, idx) => (
                    <Polyline
                        key={`polyline-${idx}`}
                        path={decodePolyline(trip.overview_polyline)}
                        options={options}
                    />
                ))}
                <></>
            </GoogleMap>
        );
    };
    const loadRightGoogleMap = () => {
        return (
            <GoogleMap
                mapContainerStyle={containerStyle}
                zoom={13}
                onLoad={(mapInstance) => onLoadBounds(mapInstance, rightMapPositions)}
                onUnmount={onUnmount}
                defaultOptions={defaultMapOptions}
                options={{
                    mapId: getMapIdBasedonEnvironment(),
                }}
            >
                {rightMapPositions.map((marker, idx) => (
                    <React.Fragment key={marker.lat + marker.lng + idx}>
                        <Marker
                            position={marker}
                            icon={{
                                url: marker.icon,
                            }}
                        />

                        <OverlayView
                            position={{ lat: marker.lat, lng: marker.lng }}
                            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                        >
                            <div className="marker-number-circle">{idx + 1}</div>
                        </OverlayView>
                    </React.Fragment>
                ))}

                <Polyline
                    key={`polyline-x`}
                    path={decodePolyline(transportData.overview_polyline)}
                    options={options}
                />

                <></>
            </GoogleMap>
        );
    };
    const renderSpinner = () => (isLoading ? <Spinner /> : null);

    const onLoadBounds = (mapInstance, positions) => {
        if (!mapInstance) return;
        const bounds = new window.google.maps.LatLngBounds();
        positions.forEach((child) => {
            bounds.extend(new window.google.maps.LatLng(child.lat, child.lng));
        });
        mapInstance.fitBounds(bounds);
        setMap(mapInstance);
    };

    const defaultMapOptions = {
        fullscreenControl: true,
    };

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null);
    }, []);

    const containerStyle = {
        width: "100%",
        height: "50vh",
    };

    const options = {
        fillColor: "lightblue",
        fillOpacity: 1,
        strokeColor: "blue",
        strokeOpacity: 1,
        strokeWeight: 2,
        clickable: false,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 1,
    };

    const columns = [
        {
            title: "#",
            render: (_, __, index) => index + 1,
            width: 60,
            align: "center",
        },
        {
            title: "Origin",
            dataIndex: "shortened_origin_address",
            key: "shortened_origin_address",
        },
        {
            title: "Destination",
            dataIndex: "shortened_destination_address",
            key: "shortened_destination_address",
        },
        {
            title: "Distance",
            dataIndex: "distance",
            key: "distance",
            align: "center",
        },
        {
            title: "Time",
            dataIndex: "time",
            key: "time",
            align: "center",
        },
        {
            title: "Original Payable",
            dataIndex: "original_payable_to_rider",
            key: "original_payable_to_rider",
            align: "center",
            render: (text, record) => {
                const original = Number(record.original_payable_to_rider) || 0;
                const bundle = Number(record.bundle_single_order_price) || 0;
                const isHigher = original > bundle;
                const isLower = original < bundle;

                const bgColor = isLower ? "green" : isHigher ? "red" : "#15438e";

                return (
                    <div
                        style={{
                            borderRadius: "6px",
                            padding: "4px 8px",
                            display: "inline-block",
                            color: bgColor,
                        }}
                    >
                        {original.toFixed(2)} A$
                    </div>
                );
            },
        },
        {
            title: "In Bundle Pays",
            dataIndex: "bundle_single_order_price",
            key: "bundle_single_order_price",
            align: "center",
            render: (text, record, index) => {
                const original = Number(record.original_payable_to_rider) || 0;
                const bundle = Number(editedData[index]?.bundle_single_order_price) || 0;
                const isHigher = bundle > original;
                const isLower = bundle < original;

                const bgColor = isLower ? "green" : isHigher ? "red" : "#15438e";

                return (
                    <div
                        style={{
                            borderRadius: "6px",
                            padding: "4px 8px",
                            display: "inline-block",
                            color: bgColor,
                        }}
                    >
                        {isEditing ? (
                            <input
                                type="number"
                                value={editedData[index]?.bundle_single_order_price}
                                onChange={(e) => {
                                    const newValue = e.target.value;
                                    setEditedData((prev) => {
                                        const updated = [...prev];
                                        updated[index].bundle_single_order_price = newValue;
                                        return updated;
                                    });
                                }}
                                style={{
                                    width: "90px",
                                    padding: "4px",
                                    borderRadius: "4px",
                                    border: "1px solid #bbb",
                                }}
                            />
                        ) : (
                            bundle.toFixed(2) + " A$"
                        )}
                    </div>
                );
            },
        },
    ];

    const adminFindBundledTransports = async (value) => {
        try {
            const result = await service.adminFindBundledTransports(value);
            log(result);
            if (result) {
                setLoading(false);
                switch (result.data.code) {
                    case 200:
                        handleBundleData(result.data);
                        return;
                    case 401:
                        toast.error(result.data.message);
                        return props.history.replace("/login");
                    case 500:
                        return toast.error(result.data.message);
                    default:
                        return toast.error(result.data.message);
                }
            }
        } catch (error) {
            log(error);
            toast.error(error.message);
        }
        setLoading(false);
    };

    const adminCancelBundledTransports = async (value) => {
        setLoading(true);
        try {
            const result = await service.adminCancelBundledTransports(transportData.bundle_id);
            log(result);
            if (result) {
                setLoading(false);
                switch (result.data.code) {
                    case 200:
                        setIsModalOpen(false)
                        return props.history.goBack();
                    case 401:
                        toast.error(result.data.message);
                        return props.history.replace("/login");
                    case 500:
                        return toast.error(result.data.message);
                    default:
                        return toast.error(result.data.message);
                }
            }
        } catch (error) {
            log(error);
            toast.error(error.message);
        }
        setLoading(false);
    };

    const adminEditBundledTransportsPrice = async (payload, totalBundlePays) => {
        setLoading(true);
        try {
            const result = await service.adminEditBundledTransportsPrice(transportData.bundle_id, totalBundlePays, payload);
            log(result);
            if (result) {
                switch (result.data.code) {
                    case 200:
                        toast.success(result.data.message);
                        adminFindBundledTransports(orderNumber);
                        return;
                    case 401:
                        setLoading(false);
                        toast.error(result.data.message);
                        return props.history.replace("/login");
                    case 500:
                        setLoading(false);
                        return toast.error(result.data.message);
                    default:
                        setLoading(false);
                        return toast.error(result.data.message);
                }
            }
        } catch (error) {
            log(error);
            setLoading(false);
            toast.error(error.message);
        }

    };

    function handleBundleData(data) {
        setTransportData(data);
        const positionsLeftData = [];
        for (const trip of data.original_transport_details_for_admin) {
            positionsLeftData.push(
                {
                    lat: trip.origin_lat,
                    lng: trip.origin_lng,
                    icon: origin,
                    zIndex: 9,
                },
                {
                    lat: trip.destination_lat,
                    lng: trip.destination_lng,
                    icon: destination,
                    zIndex: 9,
                }
            );
        }
        setLeftMapPositions(positionsLeftData);

        const positionsRightData = data.bundled_path_with_delivery_action.map(
            (trip) => ({
                lat: trip.lat,
                lng: trip.lng,
                icon: trip.delivery_action === "pickup" ? origin : destination,
                zIndex: 9,
            })
        );
        setRightMapPositions(positionsRightData);

        if (data.is_bundled_has_rider) {
            setAssignBearerType(data.bearer_type)
            getRiderAvatar(data.rider_avatar_url)
            let items = [
                {
                    key: '1',
                    label: 'Name',
                    children: data.rider_given_name + " " + data.rider_last_name,
                },
                {
                    key: '5',
                    label: 'Mode of Transport',
                    children: data.bearer_type,
                },
            ]

            if (data.bearer_type === "driving") {
                items.push(
                    {
                        key: '7',
                        label: 'Car Make',
                        children: data.car_make ? data.car_make : "",
                    },
                    {
                        key: '8',
                        label: 'Car Model',
                        children: data.car_model ? data.car_model : "",
                    },
                    {
                        key: '9',
                        label: 'Car Registration number',
                        children: data.car_registration_number ? data.car_registration_number : "",
                    },
                    {
                        key: '9',
                        label: 'Car Registration State',
                        children: data.car_registration_state ? data.car_registration_state : "",
                    }
                );
            } if (data.bearer_type === "riding") {
                items.push(
                    {
                        key: '7',
                        label: 'Motorbike Make',
                        children: data.motorbike_make ? data.motorbike_make : "",
                    },
                    {
                        key: '8',
                        label: 'Motorbike Model',
                        children: data.motorbike_model ? data.motorbike_model : "",
                    },
                    {
                        key: '9',
                        label: 'Motorbike Registration number',
                        children: data.motorbike_registration_number ? data.motorbike_registration_number : "",
                    },
                    {
                        key: '9',
                        label: 'Motorbike Registration State',
                        children: data.motorbike_registration_state ? data.motorbike_registration_state : "",
                    }
                );
            }
            setRiderItems(items)

        }

    }

    function calculateTotalBundlePays() {
        return editedData.reduce(
            (sum, row) => sum + (Number(row.bundle_single_order_price) || 0),
            0
        );
    }

    const handleOnlineRiderList = async () => {
        setLoading(true);
        try {
            const result = await service.adminGetOnlineRidersForAssignment(
                searchRiderLimitOnlineStateTime,
                transportData.origin_lat,
                transportData.origin_lng,
                false,
                false,
                assignTransportRiding,
                assignTransportDriving
            );
            log(result);
            if (result) {
                setLoading(false);
                switch (result.data.code) {
                    case 200:
                        setAssignBearerRiders(result.data.riders);
                        if (result.data.riders.length > 0) {
                            setShowRiderListModal(true);
                        } else {
                            toast.error("No Bearers found");
                        }
                        setShowAssignToNewRider(false);
                        return;
                    case 401:
                        toast.error(result.data.message);
                        return this.props.history.replace("/login");
                    case 500:
                        return toast.error(result.data.message);
                    default:
                        return toast.error(result.data.message);
                }
            }
        } catch (error) {
            toast.error(error.message);
        }
        setLoading(false);
    };

    const handleSelectedRider = async (riderId) => {
        setLoading(true);
        try {
            const result = await service.adminBundledAssignToNewRider(riderId, transportData.bundle_id);
            log(result);
            if (result) {
                setLoading(false);
                switch (result.data.code) {
                    case 200:
                        adminFindBundledTransports(transportData.order_number)
                        return;
                    case 401:
                        toast.error(result.data.message);
                        return this.props.history.replace("/login");
                    case 500:
                        return toast.error(result.data.message);
                    default:
                        return toast.error(result.data.message);
                }
            }
        } catch (error) {
            toast.error(error.message);
        }
        setLoading(false);
    };

    const handleSearchNewRider = () => {
        if (
            (assignTransportDriving ||
                assignTransportRiding) &&
            searchRiderLimitOnlineStateTime.length > 0
        ) {
            handleOnlineRiderList()
        } else {
            toast.error(
                "Make sure you enter number and select at least one of the tranport modes "
            );
        }

    }


    const getRiderInfo = async () => {
        setLoading(true);
        try {
            const result = await service.adminGetRiderInfo(
                transportData.rider_user_id
            );
            log(result);
            if (result) {
                setLoading(false);
                switch (result.data.code) {
                    case 200:
                        if (result.data.rider.is_sign_up_completed) {
                            props.history.push("/home/findRider/riderList/riderSingle", {
                                riderId: result.data.rider.rider_uid,
                            });
                        } else {
                            props.history.push("/home/findRider/riderList/uncompletedRider", {
                                riderId: result.data.rider,
                            });
                        }
                        return;
                    case 401:
                        toast.error(result.data.message);
                        return this.props.history.replace("/login");
                    case 500:
                        return toast.error(result.data.message);
                    default:
                        return toast.error(result.data.message);
                }
            }
        } catch (error) {
            toast.error(error.message);
        }
        setLoading(false);
    };


    return (
        <div className="table-design car-list-history show-all-list bundle-transport ">
            <ToastContainer />
            {renderSpinner()}
            {transportData &&
                <>

                    {rightMapPositions.length > 0 && leftMapPositions.length > 0 && (
                        <Row>
                            <Col md={6}>
                                <h5 style={{ textAlign: "left", margin: "10px 0" }}>
                                    Single Order Routes
                                </h5>
                                <div className="map">{loadLeftGoogleMap()}</div>
                            </Col>
                            <Col md={6}>
                                <h5 style={{ textAlign: "left", margin: "10px 0" }}>
                                    Bundled Order Route
                                </h5>
                                <div className="map">{loadRightGoogleMap()}</div>
                            </Col>
                        </Row>
                    )}
                    <Table
                        columns={columns}
                        dataSource={editedData}
                        pagination={false}
                        rowKey={(_, index) => index}
                        bordered
                        style={{ margin: "20px 0 " }}
                        summary={(pageData) => {
                            const totalOriginalPayable = pageData.reduce(
                                (sum, row) => sum + (Number(row.original_payable_to_rider) || 0),
                                0
                            );
                            const totalBundlePays = pageData.reduce(
                                (sum, row) => sum + (Number(row.bundle_single_order_price) || 0),
                                0
                            );

                            return (
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} colSpan={5} align="right">
                                        Total
                                    </Table.Summary.Cell>

                                    <Table.Summary.Cell index={1} align="center">
                                        <span
                                            style={{
                                                color: "white",
                                                padding: "5px",
                                                borderRadius: "4px",
                                                backgroundColor:
                                                    totalOriginalPayable < totalBundlePays
                                                        ? "green"
                                                        : totalOriginalPayable > totalBundlePays
                                                            ? "red"
                                                            : "#15438e",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {totalOriginalPayable.toFixed(2)} A$
                                        </span>
                                    </Table.Summary.Cell>

                                    <Table.Summary.Cell index={2} align="center">
                                        <span
                                            style={{
                                                color: "white",
                                                padding: "5px",
                                                borderRadius: "4px",
                                                backgroundColor:
                                                    totalBundlePays < totalOriginalPayable
                                                        ? "green"
                                                        : totalBundlePays > totalOriginalPayable
                                                            ? "red"
                                                            : "#15438e",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {totalBundlePays.toFixed(2)} A$
                                        </span>
                                    </Table.Summary.Cell>
                                </Table.Summary.Row>
                            );
                        }}
                    />

                    <div className="extra-info">
                        <Space.Compact block>
                            <div className="title">Total Travelling Distance: </div>
                            <div className="value">{transportData.bundle_length}</div>
                        </Space.Compact>
                        <Space.Compact block>
                            <div className="title">Total Driving Time: </div>
                            <div className="value">{transportData.bundle_duration} min</div>
                        </Space.Compact>
                        <Space.Compact block>
                            <div className="title">Total Time to Complete:</div>
                            <div className="value">{transportData.bundle_time}</div>
                        </Space.Compact>
                        <Space.Compact block>
                            <div className="title">Starting Address:</div>
                            <div className="value">{transportData.shortened_first_origin_address}</div>
                        </Space.Compact>
                        <Space.Compact block>
                            <div className="title">Ending Address:</div>
                            <div className="value">{transportData.shortened_last_destination_address}</div>
                        </Space.Compact>
                    </div>

                    {transportData.is_bundled_has_rider &&
                        <>
                            <Divider style={{ margin: "40px 0" }}>
                                <img src={riderImage} width={80} height={80} style={{ borderRadius: 5 }} />
                            </Divider>
                            <Descriptions bordered items={riderItems} />
                        </>
                    }


                    <div className="load-more">
                        <ul style={{ margin: "20px 0" }}>

                            {transportData.is_bundled_has_rider &&
                                <li style={{ display: "inline-block" }}>
                                    <button onClick={() => getRiderInfo()} >More Rider Info</button>
                                </li>
                            }
                            {transportData.bundle_latest_state === "Created" &&
                                <>

                                    <li style={{ display: "inline-block" }}>
                                        <button onClick={showModal} >Cancel & Unlock</button>
                                    </li>
                                    <li style={{ display: "inline-block" }}>
                                        <button
                                            onClick={() => {
                                                if (isEditing) {
                                                    const payload = editedData.map(item => ({
                                                        transport_id: item.transport_id,
                                                        price: Number(item.bundle_single_order_price)
                                                    }));

                                                    const totalBundlePays = calculateTotalBundlePays();
                                                    setTransportData(prev => ({
                                                        ...prev,
                                                        bundle_receivable_price: totalBundlePays
                                                    }));

                                                    adminEditBundledTransportsPrice(payload, totalBundlePays);
                                                }
                                                setIsEditing(!isEditing);
                                            }}
                                        >
                                            {isEditing ? "Save Changes" : "Edit Bundle"}
                                        </button>
                                    </li>
                                    <li>
                                        <button onClick={() => setShowAssignToNewRider(true)}>
                                            Assign to New Rider
                                        </button>
                                    </li>
                                </>
                            }
                        </ul>
                    </div>


                    <Modal
                        title="Cancel Bundle"
                        closable={{ 'aria-label': 'Custom Close Button' }}
                        open={isModalOpen}
                        onOk={handleOk}
                        okText="Yes"
                        onCancel={handleCancel}
                    >
                        <p>Do you realy want to cancel this bundle?</p>
                    </Modal>
                    <Modal
                        open={showAssignToNewRider}
                        title="Assign to New Rider"
                        onOk={handleSearchNewRider}
                        okText="Search"
                        onCancel={() => setShowAssignToNewRider(false)}
                        cancelText="Close"
                    >
                        <Row>
                            <Col md="12">
                                <Input
                                    label="Latest Online Time in Minutes:"
                                    type="number"
                                    name="title"
                                    value={searchRiderLimitOnlineStateTime}
                                    onChange={(e) => {
                                        if (e.target.value !== 0) {
                                            setSearchRiderLimitOnlineStateTime(e.target.value);
                                        }
                                    }}
                                    style={{ marginTop: 10 }}
                                    className="margin-top-bottom"
                                />
                            </Col>
                            <Col md="12" style={{ marginBottom: 10 }}>
                                Bearer Type:
                            </Col>
                            <Col md="3">
                                <label style={{ display: "flex", alignItems: "center" }}>
                                    <input
                                        type="checkbox"
                                        checked={assignTransportDriving}
                                        onChange={() => {
                                            setAssignTransportDriving(!assignTransportDriving);
                                        }}
                                        style={{ height: 30, marginBottom: 0, marginRight: 5 }}
                                    />
                                    Driving
                                </label>
                            </Col>
                            <Col md="3">
                                <label
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        opacity: assignBearerType === "driving" ? 0.2 : 1,
                                    }}
                                >
                                    <input
                                        disabled={assignBearerType === "driving" ? true : false}
                                        type="checkbox"
                                        checked={assignTransportRiding}
                                        onChange={() => {
                                            setAssignTransportRiding(!assignTransportRiding);
                                        }}
                                        style={{ height: 30, marginBottom: 0, marginRight: 5 }}
                                    />
                                    Riding
                                </label>
                            </Col>
                            <Col md="3">
                                <label
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        opacity: 0.2
                                    }}
                                >
                                    <input
                                        disabled={true}
                                        type="checkbox"
                                        style={{ height: 30, marginBottom: 0, marginRight: 5 }}
                                    />
                                    Cycling
                                </label>
                            </Col>
                            <Col md="3" style={{ marginBottom: 20 }}>
                                <label
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        opacity: 0.2,
                                    }}
                                >
                                    <input
                                        disabled={true}
                                        type="checkbox"
                                        style={{ height: 30, marginBottom: 0, marginRight: 5 }}
                                    />
                                    Walking
                                </label>
                            </Col>
                        </Row>
                    </Modal>
                    <Modal
                        open={showRiderListModal}
                        className="chat-modal search-list assign-rider-list"
                        style={{ minWidth: 900 }}
                        title="Assign to New Rider"
                        onCancel={() => setShowRiderListModal(false)}
                        cancelText="Close"
                        okButtonProps={{ style: { display: 'none' } }}
                        getContainer={() =>
                            document.querySelector('.main-data-section')
                        }
                    >
                        <table className="table">
                            <thead style={{ textAlign: "center" }}>
                                <tr>
                                    <th>Full Name</th>
                                    <th>Mobile Number</th>
                                    <th>Mode of Transport</th>
                                    <th>Latest Online Time</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody style={{ textAlign: "center" }}>
                                {assignBearerRiders.map((rider) => (
                                    <tr key={rider.rider_uid}>
                                        <td>{rider.given_name + " " + rider.last_name}</td>
                                        <td>{rider.mobile_number}</td>
                                        <td>
                                            {handleTransportModeImage(rider.mode_of_transport)}
                                        </td>
                                        <td>
                                            {timestampToDateFull(rider.last_state_update)}
                                        </td>
                                        <td>
                                            <button
                                                className="search-view"
                                                onClick={() => handleSelectedRider(rider.rider_uid)}
                                            >
                                                Select Bearer
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                className="search-view"
                                                onClick={() =>
                                                    props.history.push(
                                                        "/home/findRider/riderList/riderSingle",
                                                        {
                                                            riderId: rider.rider_uid,
                                                        }
                                                    )
                                                }
                                            >
                                                View Profile
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Modal>

                </>
            }
        </div >
    );


}

export default BundledOrderSingle;
